/**
 * Created by Markus on 15.6.2015.
 * In this case sections are considered the level 1 pages that have children (1 or more)
 */

define('helperNavigation-getSectionNFromEndId',['helperContent-getSectionEntities'], function(getSectionEntities) {
    'use strict';

    var getSectionNFromEndID = function(sectionNumber, arr) {
        var i, res, entity, sectionNumber, sections, section;

        if (!Array.isArray(arr)) {
            return null;
        }

        i = arr.length;
        arr = [].concat(arr);
        sections = getSectionEntities(arr);

        section = sections[(sections.length-sectionNumber)];

        return (section.hasOwnProperty('contentEntityId')) ? section.contentEntityId : null;
    };

    return getSectionNFromEndID;

});

